class OP3MovingImage {
    constructor(selector, $) {
        this.selector = selector;
        this.$ = $;
        this.items = [];

        let _this = this;
        $(selector).each((index, element) => {
            let $this = $(element);
            let heightDifference = parseInt($this.find('img').height() - $this.height());
            if (heightDifference > 0) {
                $this.attr('data-transform-y', heightDifference);
                $this.find('img').css('transition', `transform ${heightDifference / 200}s ease-in-out`);
                $this
                    .hover(
                        () => {
                            $this.find('img').css('transform', `translateY(-${$this.attr('data-transform-y')}px)`);
                        },
                        () => {
                            $this.find('img').css('transition', `transform 0.3s ease-in-out`);
                            $this.find('img').css('transform', ``);
                        }
                    )
                ;
                _this.items.push($this);
            }
        });
    }

    destroy() {
        let _this = this;

        _this.items.forEach( ($image) => {
            $image.unbind();
        });

        _this.items = [];
    }
}

export default OP3MovingImage;


// WEBPACK FOOTER //
// ./resources/assets/js/Element/MovingImage.js